import { Component, OnInit, inject } from '@angular/core';
import { ICustomerAccountVisit } from '@app/customer-account/models/customer-account-visit.model';
import { VisitStatusEnum } from '@app/customer-account/models/visit-status.enum';
import { CustomerAccountVisitsService } from '@app/customer-account/services/customer-account-visits.service';
import { ThemeService } from '@app/salon-details/services/theme.service';
import { inOutAnimation } from '@app/shared/utils';

@Component({
  selector: 'app-customer-account-visits',
  templateUrl: './customer-account-visits.component.html',
  styleUrls: ['./customer-account-visits.component.scss'],
  animations: [inOutAnimation]
})
export class CustomerAccountVisitsComponent implements OnInit {

  pendingVisits: ICustomerAccountVisit[] = [];
  visitsHistory: ICustomerAccountVisit[] = [];
  private themeService = inject(ThemeService);

  constructor(private customerAccountVisitsService: CustomerAccountVisitsService) { }

  ngOnInit() {
    this.themeService.useDefaultTheme();
    this.loadPendingVisits();
    this.loadHistoryVisits();
  }

  visitCancelled(visitId: string): void {
    const cancelledVisit = this.pendingVisits
      .splice(this.pendingVisits.findIndex(visit => visit.visitId === visitId), 1);
    cancelledVisit[0].visitStatus = VisitStatusEnum.Cancelled;
    this.visitsHistory.unshift(cancelledVisit[0]);
  }

  private loadPendingVisits(): void {
    this.customerAccountVisitsService.getPendingVisits()
      .subscribe(visits => this.pendingVisits = visits);
  }

  private loadHistoryVisits(): void {
    this.customerAccountVisitsService.getVisitsHistory()
      .subscribe(visits => this.visitsHistory = visits);
  }
}
